import {AppContext} from "../../lib/AppContext";
import React, {useContext, useState} from "react";
import Meta from "../common/Meta";
import MDBox from "../../components/MDBox";
import CustomerPageLayout from "../Layout/CustomerPageLayout";
import {subscribeNewsletter} from "../common/api/PortalCustomerApi";
import CustomerHeader from "../common/CustomerHeader";

export default function Newsletter(props) {

  const [context, setContext] = useContext(AppContext);
  const [newsletterSubscribed, setNewsletterSubscribed] = useState(false);


  const [psbRef, setPsbRef] = useState("psb6-432-charge");
  const [newsletterEmail, setNewsletterEmail] = useState();
  const [newsletterName, setNewsletterName] = useState();
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [formResponse, setFormResponse] = useState();

  const [newsLetterMode, setNewsletterMode] = useState(props?.newsletterMode);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const jsonData = {
      email: newsletterEmail,
      legacyRef: psbRef
    }
    subscribeNewsletter(jsonData).then((resp) => {
      setNewsletterSubscribed(true);
      setSubmitted(true);
      setSubmitting(false);
    })
  }

  return (

    <>


      <CustomerPageLayout>

        <Meta pageTitle={'Newsletter'}/>

        {!newsLetterMode && <>
          <CustomerHeader props={props}/>
        </>
        }

        <MDBox py={3}>
          <center>
            <div className="row px-5 pb-5">
              <div className="col-md-3 col-sm-12">
                &nbsp;
              </div>
              <div className="col-md-6">
                {submitted && <center><h5>Thank you!</h5></center>}
                {!submitted && <div style={{
                  margin: '0 auto'
                }}>
                  <form onSubmit={handleSubmit}>
                    <input type="password" style={{
                      position: 'absolute',
                      top: '20px',
                      left: '-999em'
                    }} id={"psbRef"} name={"psbRef"}
                           autoComplete="off"
                           onChange={(e) => {
                             setPsbRef(e.target.value);
                           }}
                    />

                    <h5>Subscribe to our Newsletter</h5>

                    <div className="input-group mb-3">

                      <input type="text" required className="form-control" name={"newsletterName"}
                             placeholder="Your Name"
                             disabled={submitting}
                             onChange={(e) => {
                               setNewsletterName(e.target.value)
                             }} id={"newsletterName"}
                      />
                    </div>
                    <div className="input-group mb-3">

                      <input type="text" required className="form-control" name={"newsletterEmail"}
                             placeholder="Your Email"
                             disabled={submitting}
                             onChange={(e) => {
                               setNewsletterEmail(e.target.value)
                             }} id={"newsletterEmail"}
                      />

                      <button className="btn btn-secondary" type="submit"
                              style={{
                                border: 'solid 1px #ddd'
                              }}
                              disabled={!newsletterEmail || !newsletterEmail?.length || submitting}
                              id="button-addon1">{submitting ? 'Sending...' : 'Sign up'}
                      </button>
                    </div>

                  </form>
                </div>
                }
              </div>
            </div>
          </center>
        </MDBox>

      </CustomerPageLayout>

    </>
  );
}